import React, { PropTypes } from 'react';
import Translate from 'react-translate-component';
import { proxyCounterpart } from '../../../scripts/proxyCounterpart';
import { GeneralError, SpinnerButton, InputField } from 'components';
import { UserService } from 'frilans-finans';
import Modal from 'react-modal';

export class Ssnr extends React.Component {

  static contextTypes = {
    user: PropTypes.object.isRequired

  };

  static propTypes = {
    onCloseModal: PropTypes.func.isRequired
  };

  constructor (props, context) {
    super(props, context);

    this.state = {
      open: true,
      showErrorWithoutBlur: false,
      ssnr: { valid: false, value: '' },
      posting: false,
      postError: false,
      activateSubmitButton: false
    };

    this.callback = this.callback.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.clickSubmit = this.clickSubmit.bind(this);
    this.handleSuccess = this.handleSuccess.bind(this);
    this.handleError = this.handleError.bind(this);
  }

  callback (name, values) {
    this.setState({ ssnr: values, activateSubmitButton: !!values.valid });
  }

  clickSubmit (e) {
    e.preventDefault();

    this.setState({showErrorWithoutBlur: true}, () => {
      if (this.state.ssnr.valid) {
        this.submitForm();
      }
    });
  }

  submitForm () {
    var params = { 'socialSecurityNr': this.state.ssnr.value };

    UserService.updateSsnr(params)
      .then(this.handleSuccess)
      .catch(this.handleError);

    this.setState({
      posting: true,
      postError: false
    });
  }

  handleSuccess () {
    this.setState({
      posting: false,
      postError: false
    });

    this.props.onCloseModal();
  }

  handleError (error) {
    let errors = UserService.getError(error);

    this.setState({
      posting: false,
      postError: true,
      errorMessage: errors
    });
  }

  renderPostError () {
    if (this.state.postError) {
      if (!this.state.errorMessage) {
        return (<GeneralError />);
      } else {
        return (
          <div>
            {this.state.errorMessage.map((error, i) => {
              return (
                <p className='error' key={i}>{error}</p>
              );
            })}
          </div>
        );
      }
    }
  }

  render () {
    const errorMessage = this.state.ssnr.value.replace(/\D+/g, '').length !== 12
      ? 'PERSONAL_NUMBER_ERROR'
      : 'PERSONAL_NUMBER_ERROR_BACKEND';

    return (
      <Modal
        className='modal-pop-complete-information'
        contentLabel=''
        isOpen={this.state.open}
        onRequestClose={this.props.onCloseModal}>
        <div className='modal-left-column'>
          <h2><Translate content='SSNR_MODAL_HEADER'/></h2>
          <p><Translate content='SSNR_MODAL_TEXT'/></p>
          <div className='info-text-bottom'>
            <h6><Translate content='SSNR_MODAL_SMALL_TEXT'/></h6>
            <div>
              <InputField
                type='text'
                inputMode='numeric'
                validationType='personalNumber'
                name='socialSecurityNr'
                placeholder={proxyCounterpart('SSNR_MODAL_PLACEHOLDER')}
                callback={this.callback}
                required='true'
                minLength='3'
                errorMessage={proxyCounterpart(errorMessage)}
                showErrorWithoutBlur={this.state.showErrorWithoutBlur} />
                {this.renderPostError()}
              <div className='button-holder'>
                <SpinnerButton
                  text={proxyCounterpart('SAVE')}
                  loading={this.state.posting}
                  classes='btn cover'
                  callback={this.clickSubmit}
                  disabled={!this.state.activateSubmitButton}
                  />
              </div>
            </div>
          </div>

        </div>
        <div className='modal-right-column'>
          <img src={proxyCounterpart('SSNR_MODAL_IMAGE')}/>
        </div>
      </Modal>
    );
  }
}

export default Ssnr;



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/ssnr/ssnr.js
 **/